export default "__VITE_ASSET__l47wAA6___"